// extracted by mini-css-extract-plugin
module.exports = {"DescriptionTextArea":"description_DescriptionTextArea__11H08","SaveButton":"description_SaveButton__dcLnU"};